import React, { Component } from 'react'
import moment from 'moment';
import MovieTimes from './MovieTimes';
import ItemAttributes from './ItemAttributes';
import getDateYear from '../../../functions/getDateYear';
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek';
import setMomentDateObjZero from '../../../functions/setMomentDateObjZero';
import getMomentDateObj from '../../../functions/getMomentDateObj';


class FlyerMovie extends Component {
    constructor(props) {
        super(props);
    }

    getHasFlyerCaptionsActive() {
        const { hasFlyerCaptions } = this.props
        const { technologyAttributes } = this.props.movieData

        if(technologyAttributes.length === 1) {
            return false
        } else {
            return hasFlyerCaptions
        }
    }

    getAttributes(hasFlyerCaptionsActive) {
        const { fsk, length, performances } = this.props.movieData
        const { week } = this.props
        let attributeArr = []
        const year = moment().week() < week ? getDateYear() + 1 : getDateYear()
        
        const weekStartdate = setMomentDateObjZero(getFromWeekCinemaStartDate(week, year))
        const weekEnddate = setMomentDateObjZero(getFromWeekCinemaEndDate(week, year))
        let colorToUse = 1

        performances.map(perf => {
            const {attributes, timeUtc, cinemaId} = perf

            const performanceDate = setMomentDateObjZero(getMomentDateObj(timeUtc)) //TIMEZONE MISSING
            if(weekStartdate.isSameOrBefore(performanceDate) && performanceDate.isSameOrBefore(weekEnddate) && cinemaId === this.props.currentCinemaId) {
                attributes.map(attr => {
                    if(attr.id === '1087' || attr.id === '2d' || attr.id === 'digital') {
                        return ''
                    } else {
                        const containsAttr = _.find(attributeArr, attrArr => {
                            return attrArr.id === attr.id
                        })
                        if(!containsAttr) {
                            attributeArr.push({
                                id: attr.id,
                                name: attr.name,
                                colorToUse: colorToUse
                            })
                            colorToUse++
                        }

                    }
                })
            }
        })

        const sortedAttributesArr = attributeArr.sort(function(a, b) {
            const attrName = a.name
            const bAttrName = b.name 
    
            return bAttrName > attrName ? -1 : bAttrName < attrName ? 1 : 0
        })

        const attributes = !hasFlyerCaptionsActive ? sortedAttributesArr : []
    
        if(fsk !== null && fsk !== -1) {
            attributes.push({
                id:'fsk',
                name: fsk
            })
        }
    
        if(length) {
            attributes.push({
                id:'length',
                name: length
            })
        }
    
        return attributes
    }

    getTruncateText(text, maxLength) {
        if (!text || text.length <= maxLength) {
          return text;
        }
        const shortText = text.substr(0, maxLength)
        const arr = shortText.split(" ")
        arr.pop();
        const joined = arr.join(' ');
    
        return joined + '\u2026'
    }

    getDescription() {
        const { description, movieData } = this.props 
        const { descriptionShort } = movieData

        if(description && 'long' === description) {
            return descriptionShort
        } else {
            return this.getTruncateText(descriptionShort, 145)
        }
    }

    getCurrentTitle() {
        const {title, titleDisplay } = this.props.movieData

        return titleDisplay ? titleDisplay : title
    }

    getPosterStyles() {
        const { images, posterURL } = this.props.movieData
        const { poster } = images
        const posterUrlStyle = poster ? poster.url : posterURL ? posterURL : ''
        let sizeQuery = ''

        if(posterUrlStyle && (posterUrlStyle.search("orchestrationlayer.cloudticket.net") !== -1 || posterUrlStyle.search("cineorder-content-uat.cloudticket.net") !== -1 ||posterUrlStyle.search("contentservice.cineorder.shop") !== -1)) {
            sizeQuery = "&size=600"
        }  

        if(posterUrlStyle) {
            return {
                backgroundImage: `url(${posterUrlStyle + sizeQuery})`
            }
        } else {
            return false
        }
    }


    render() {
        const { movieData, movieTimesDesktop, colors, iconsColor, hideTheatres, translation, cinemaData, week, captionAttributes, hasFlyerCaptions, periodesDays, style } = this.props
        const {title, performances } = movieData
        const { accent_color_dark, theme_colors, accent_color, chosen_font} = colors
        const accentColorDark = accent_color_dark
        const accentColor = accent_color
        const currentTitle = this.getCurrentTitle()
        const posterStyles = this.getPosterStyles()
        const hasFlyerCaptionsActive = this.getHasFlyerCaptionsActive()
        const attributes = this.getAttributes(hasFlyerCaptionsActive)
        const isExtended = style === 'extended'

        return (
            <div className={"slide-item" + ' style-' + style}>
                <div className="movie-information-wrapper">

                    {isExtended && (posterStyles ? (
                        <div className="poster-format-item">
                            <div className="poster" style={posterStyles}><p className="screen-reader-text">{title} Filmposter</p></div>
                        </div> 
                    ) : (
                        <div className="no-image-container">
                            <div className="no-image"><span className="screen-reader-text">{title}</span></div>
                        </div>
                    ))}

                    <div className="inner-movie-information">
                        <div className='info-wrapper'>
                            {currentTitle && <h2 className={`movie-title ${chosen_font}-text-small-black`}>
                                {currentTitle}
                            </h2>}

                            <div className="attributes-wrapper">
                                <ItemAttributes 
                                    hide2d={hasFlyerCaptions ? false : true} 
                                    accentColorDark={accentColorDark} 
                                    accentColor={accentColor} 
                                    chosen_font={chosen_font} 
                                    translation={translation} 
                                    performances={performances} 
                                    themeColors={theme_colors} 
                                    attributes={attributes}
                                    iconsColor={iconsColor}
                                    />            
                            </div>
                        </div>

                        {isExtended && <div className={`description ${chosen_font}-text-xxsmall-light`}>
                            {this.getDescription()}
                        </div>}

                        <MovieTimes
                            reducedVersion={true}
                            flyerDate={true}
                            cinemaData={cinemaData}
                            chosen_font={chosen_font} 
                            attributesColors={attributes}
                            showMovieTimesSortedAfterTheatres={movieTimesDesktop}
                            periodesDays={periodesDays}
                            hasFlyerCaptions={hasFlyerCaptionsActive}
                            captionAttributes={captionAttributes}
                            movieData = {movieData}
                            performances={performances}
                            activeWeek={week}
                            hideTheatres={hideTheatres}
                            colors={colors}
                            iconsColor={iconsColor}
                        />
                    </div>
                </div>
            </div>

        )
    }
}

export default FlyerMovie